import { render, staticRenderFns } from "./company-data.vue?vue&type=template&id=fc739cca&scoped=true"
import script from "./company-data.vue?vue&type=script&lang=js"
export * from "./company-data.vue?vue&type=script&lang=js"
import style0 from "./company-data.vue?vue&type=style&index=0&id=fc739cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc739cca",
  null
  
)

export default component.exports